import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UnsavedWorkService {
  // Signal to track if there is unsaved work anywhere in the app
  unsavedWork = signal(false);

  setUnsaved(hasUnsaved: boolean) {
    this.unsavedWork.set(hasUnsaved);
  }

  clear() {
    this.unsavedWork.set(false);
  }
}
